import React, { useRef, useEffect } from "react";

function StatusBar({ data, loading = false, onClick, setIsOverflowing = () => { }, expanded = false, isOverflowing = false }) {

    const containerRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current) {
                const container = containerRef.current;
                const firstRowBottom = container.children[0]?.offsetTop + container.children[0]?.offsetHeight;
                let overflowing = false;
                for (let i = 1; i < container.children.length; i++) {
                    if (container.children[i].offsetTop > firstRowBottom) {
                        overflowing = true;
                        break;
                    }
                }
                setIsOverflowing(overflowing);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [data]);

    return (
        <div>
            <div
                className={`statusbar-con ${expanded ? "expanded" : "collapsed"}`}
                ref={containerRef}
            >
                {data.map((item, index) => (
                    <div
                        key={`${item.title}-${index}`}
                        className="status-card"
                        onClick={onClick ? () => onClick(item.value) : null}
                    >
                        <label className="status-title">{item.title.charAt(0).toUpperCase() + item.title.slice(1).toLowerCase()}</label>
                        {loading ? (
                            <div className="spinner-vsmall" />
                        ) : (
                            <label className="status-label">{item.label ?? 0}</label>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default StatusBar;